import {Injectable} from "@angular/core";
import gql from "graphql-tag";
import {Observable} from "rxjs/Observable";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {VisbosService} from "../../../core/visbos-core/graphql/visbos.service";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store/store";
import {SessionActions} from "../../../shared/actions/session.actions";
import {map} from "rxjs/operators";
import {FetchPackingUnitsQueryQuery} from "../../../shared/graphql/graphql.types";

export const fetchPackingUnitsQuery = gql`
  #Fetch Packing Units
  query FetchPackingUnitsQuery($AU: String) {
    fetchPackingUnits(administration_unit_cuid: $AU){
      cuid, label, packing_unit_name, packing_unit_short, packing_unit_plural, has_content
      administration_unit {
        cuid, label
      }
    }
  }`;

@Injectable()
export class PackingUnitService extends VisbosService {

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getPackingUnitList(administration_unit_cuid?: string | Observable<string>): Observable<any> {

    let data$ = this.getPackingUnitListQuery(administration_unit_cuid);
    return data$.pipe(
      map(({data}: any) => data.fetchPackingUnits)
    );
  }

  public getPackingUnitListQuery(administration_unit_cuid?: string | Observable<string>): ApolloQueryObservable<FetchPackingUnitsQueryQuery> {
    return this.fetchItems({
      query: fetchPackingUnitsQuery,
      variables: {
        AU: administration_unit_cuid
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/packing-unit/packing-unit.service.ts